import React, { useState, useEffect } from "react";
import { profileDb } from "../../../db/dbClasses";
import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";
import SubHeader from "../../Miscellaneous/SubHeader.component";
import Header from "../../Miscellaneous/Header.component";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Contact = () => {
  const [profile, setProfile] = useState({});
  useEffect(() => {
    (async () => {
      setProfile((await profileDb.read())[0]);
    })();
  }, []);

  return (
    <div className="p-0" style={{ minHeight: "100vh" }}>
      <Header content="Contact" />
      <BoxDiv>
        <div className="w-100 p-5 pt-2">
          <div className="w-100 mx-auto p-3 font-open-sans">
            {profile?.office_door_photo && (
              <Row>
                <Col
                  md={6}
                  lg={7}
                  className="d-flex flex-column align-items-start justify-content-center"
                >
                  <div>
                    <div>
                      <h3 className="fw-b">
                        Dr. {profile?.first_name} {profile?.last_name}
                      </h3>
                      <h5 className="fw-l">{profile?.position}</h5>
                    </div>
                    <br />
                    <div>
                      <h4 className="fw-l">{profile?.office}</h4>
                      <h5 className="fw-l">{profile?.department}</h5>
                      <h5 className="fw-l">{profile?.university}</h5>
                      <h6 className="fw-l">Phone: {profile?.telephone}</h6>
                      <span>
                        {
                          <a
                            key={profile?.email}
                            href={`mailto:${profile?.email}`}
                            style={{ color: "black" }}
                            className="d-flex flex-row align-items-center justify-content-start p-1 font-open-sans fw-l"
                          >
                            <div
                              className="footer-icon message"
                              style={{
                                height: "18px",
                                width: "18px",
                                marginRight: "5px",
                              }}
                            />
                            <span>{profile?.email}</span>
                          </a>
                        }
                      </span>
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={5}>
                  <figure>
                    <img
                      src={profile?.office_door_photo}
                      alt="office door from outside"
                      style={{
                        width: "100%",
                        height: "auto",
                      }}
                    />
                    <figcaption className="text-center">
                      Office Door from outside.
                    </figcaption>
                  </figure>
                </Col>
              </Row>
            )}
            {!profile?.office_door_photo && (
              <Row>
                <Col className="d-flex flex-column align-items-start justify-content-center">
                  <div>
                    <div>
                      <h3 className="fw-b">
                        Dr. {profile?.first_name} {profile?.last_name}
                      </h3>
                      <h5 className="fw-l">{profile?.position}</h5>
                    </div>
                    <br />
                    <div>
                      <h4 className="fw-l">{profile?.office}</h4>
                      <h5 className="fw-l">{profile?.department}</h5>
                      <h5 className="fw-l">{profile?.university}</h5>
                      <h6 className="fw-l">Phone: {profile?.telephone}</h6>
                      <span>
                        {
                          <a
                            key={profile?.email}
                            href={`mailto:${profile?.email}`}
                            style={{ color: "black" }}
                            className="d-flex flex-row align-items-center justify-content-start p-1 font-open-sans fw-l"
                          >
                            <div
                              className="footer-icon message"
                              style={{
                                height: "18px",
                                width: "18px",
                                marginRight: "5px",
                              }}
                            />
                            <span>{profile?.email}</span>
                          </a>
                        }
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </div>
          {profile?.contact_notes && (
            <React.Fragment>
              <SubHeader id="notes" content="Notes" />
              <div className="p-3 font-open-sans text-left">
                {profile?.contact_notes}
              </div>
            </React.Fragment>
          )}
        </div>
      </BoxDiv>
    </div>
  );
};

export default Contact;
